export function ByString(k: string): (a: object, b: object) => number {
  return (a: object, b: object): number => {
    const A = a[k];
    const B = b[k];
    if (A < B) {
      return -1;
    }
    if (A > B) {
      return 1;
    }
    return 0;
  };
}
